// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voice-session-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #0f172a;
  color: white;
  position: relative;
  overflow: hidden;
  font-family: 'Inter', sans-serif;
}

.voice-source-picker {
  position: absolute;
  top: 80px;
  right: 24px;
  background: rgba(30, 41, 59, 0.9);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 8px;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.voice-source-option {
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  transition: background 0.2s;
}

.voice-source-option:hover {
  background: rgba(255, 255, 255, 0.1);
}

.voice-source-option.active {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.voice-session-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  z-index: 10;
}

.voice-session-header-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.voice-session-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, #ef4444, #991b1b);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.voice-session-channel-name {
  font-weight: 700;
  font-size: 1.1rem;
  color: #f8fafc;
}

.voice-session-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  color: #94a3b8;
}

.voice-session-status {
  display: flex;
  align-items: center;
  gap: 6px;
}

.voice-session-status.connected::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #22c55e;
  box-shadow: 0 0 8px #22c55e;
}

.voice-session-subheader {
  padding: 12px 24px;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 1px solid rgba(255, 255, 255, 0.02);
}

.voice-session-pill {
  background: rgba(255, 255, 255, 0.05);
  padding: 4px 10px;
  border-radius: 100px;
  color: #ef4444;
  font-weight: 600;
  font-family: monospace;
}

.voice-session-hero {
  flex: 1;
  display: flex;
  padding: 24px;
  gap: 20px;
  min-height: 0; /* Önemli: taşmayı önler */
  overflow: hidden;
}

.voice-hero-card {
  flex: 2;
  border-radius: 24px;
  background-color: #1e293b;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.voice-hero-avatar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.voice-hero-avatar img {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  object-fit: cover;
  border: 6px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  transition: all 0.25s ease;
}

.voice-hero-avatar .voice-hero-initial {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: #5865f2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  font-weight: 800;
  color: #fff;
  border: 6px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  transition: all 0.25s ease;
}

.voice-hero-avatar.speaking img,
.voice-hero-avatar.speaking .voice-hero-initial {
  border-color: #22c55e !important;
  box-shadow: 0 0 0 4px #22c55e, 0 0 35px rgba(34, 197, 94, 0.6) !important;
  animation: heroSpeakPulse 1.2s ease-in-out infinite;
}

@keyframes heroSpeakPulse {
  0%, 100% { transform: scale(1); box-shadow: 0 0 0 4px #22c55e, 0 0 25px rgba(34, 197, 94, 0.5); }
  50% { transform: scale(1.04); box-shadow: 0 0 0 6px #22c55e, 0 0 40px rgba(34, 197, 94, 0.8); }
}

.hero-name-label {
  font-size: 1.5rem;
  font-weight: 800;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

/* Network Warning Banner */
.voice-network-warning-banner {
  background: linear-gradient(90deg, rgba(234, 88, 12, 0.95), rgba(220, 38, 38, 0.92));
  color: white;
  padding: 8px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  box-shadow: 0 4px 14px rgba(220, 38, 38, 0.35);
  z-index: 50;
  animation: bannerSlideDown 0.3s ease-out;
}

@keyframes bannerSlideDown {
  from { transform: translateY(-100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.net-warn-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.net-warn-icon {
  color: #fef08a;
  animation: warnPulse 1.2s infinite ease-in-out;
}

@keyframes warnPulse {
  0%, 100% { opacity: 0.8; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.15); }
}

.net-warn-close-btn {
  background: rgba(0, 0, 0, 0.25);
  border: none;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
}

.net-warn-close-btn:hover {
  background: rgba(0, 0, 0, 0.45);
}

.voice-session-panels {
  height: 110px;
  max-height: 110px;
  flex-shrink: 0;
  padding: 0 24px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  z-index: 10;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.voice-session-panels.collapsed {
  height: 26px;
  max-height: 26px;
  padding: 0 24px 2px;
}

.dock-toggle-tab {
  align-self: center;
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #94a3b8;
  padding: 2px 14px;
  border-radius: 12px 12px 0 0;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.dock-toggle-tab:hover {
  background: #1e293b;
  color: #fff;
  border-color: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.voice-participants-panel {
  flex: 1;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(14px);
  border-radius: 16px;
  padding: 6px 12px;
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
}

.voice-participants-grid {
  display: flex;
  gap: 12px;
  height: 100%;
  align-items: center;
}

.voice-participant-card {
  min-width: 140px;
  max-width: 160px;
  height: 80px;
  background: #1e293b;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.voice-participant-card:hover {
  transform: translateY(-2px);
  background: #334155;
}

.voice-participant-card.speaking {
  border-color: #22c55e;
  box-shadow: 0 0 15px rgba(34, 197, 94, 0.4);
}

.voice-participant-card.is-streaming {
  border-color: rgba(99, 102, 241, 0.6);
  box-shadow: 0 0 12px rgba(99, 102, 241, 0.3);
}

.voice-participant-media {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.voice-participant-avatar span {
  font-size: 1.3rem;
  font-weight: 700;
}

.voice-hero-controls {
  position: absolute;
  bottom: 14px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  padding: 8px 18px;
  background: rgba(15, 23, 42, 0.92);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.7);
  z-index: 70;
  pointer-events: auto;
  transition: opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1), transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.voice-hero-controls.auto-hidden {
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, 20px);
}

.voice-hero-controls.visible,
.voice-hero-controls:hover,
.voice-hero-card:hover .voice-hero-controls {
  opacity: 1;
  pointer-events: auto;
  transform: translate(-50%, 0);
}

.voice-hero-controls-buttons {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.voice-hero-control-button {
  width: 42px; /* Biraz küçültüldü */
  height: 42px;
  border-radius: 8px; /* Daha modern karemsi yapı */
  background: rgba(255, 255, 255, 0.05);
  border: none;
  color: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.voice-hero-control-button:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: scale(1.1);
}

.voice-hero-control-button.active {
  background: #fff;
  color: #0f172a;
}

.voice-hero-control-button.krus-btn.active {
  background: linear-gradient(135deg, #5865F2, #8b5cf6);
  color: #ffffff;
  box-shadow: 0 0 16px rgba(88, 101, 242, 0.6);
}

.voice-hero-control-button.danger {
  background: #ef4444;
  color: white;
}

.voice-hero-control-button.danger:hover {
  background: #dc2626;
  box-shadow: 0 0 20px rgba(239, 68, 68, 0.4);
}

/* Whiteboard Area (Hidden by default) */
.whiteboard-panel {
  position: absolute;
  top: 80px;
  right: 24px;
  width: 400px;
  height: calc(100% - 310px);
  background: white;
  border-radius: 16px;
  z-index: 5;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: none; /* JS ile açılacak */
}

/* Custom Scrollbar */
.voice-participants-panel::-webkit-scrollbar {
  height: 6px;
}

.voice-participants-panel::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

.voice-participants-panel::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.voice-participants-panel::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* ---- New participant card enhancements ---- */

/* Local user highlight */
.voice-participant-card.is-local {
  border-color: rgba(239, 68, 68, 0.35);
}

/* Speaking bars animation */
.speaking-bars {
  position: absolute;
  bottom: 36px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 16px;
}

.speaking-bars span {
  width: 3px;
  border-radius: 2px;
  background: #22c55e;
  animation: speakBar 0.5s ease-in-out infinite alternate;
}

.speaking-bars span:nth-child(1) { height: 6px; animation-delay: 0s; }
.speaking-bars span:nth-child(2) { height: 12px; animation-delay: 0.15s; }
.speaking-bars span:nth-child(3) { height: 8px; animation-delay: 0.3s; }
.speaking-bars span:nth-child(4) { height: 14px; animation-delay: 0.1s; }

@keyframes speakBar {
  from { transform: scaleY(0.4); opacity: 0.7; }
  to   { transform: scaleY(1); opacity: 1; }
}

/* Status icons row (top-right corner of card) */
.participant-status-icons {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  flex-direction: row;
  gap: 3px;
}

.status-icon {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

.muted-icon-badge   { background: rgba(239, 68, 68, 0.85); color: white; }
.deafened-icon-badge { background: rgba(251, 191, 36, 0.85); color: #1a1a1a; }
.camera-icon-badge  { background: rgba(34, 197, 94, 0.85); color: white; }
.screen-icon-badge  { background: rgba(99, 102, 241, 0.85); color: white; }

/* Participant name tag */
.voice-participant-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 6px 8px;
  background: linear-gradient(transparent, rgba(0,0,0,0.75));
}

.participant-name-tag {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #f8fafc;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.local-badge {
  background: #ef4444;
  color: white;
  font-size: 0.6rem;
  font-weight: 700;
  padding: 1px 4px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  flex-shrink: 0;
}

/* Voice participant avatar centered in card */
.voice-participant-avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  position: relative;
  flex-shrink: 0;
  margin-bottom: 12px;
}

.voice-participant-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.participant-live-pill {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #ef4444, #e11d48);
  color: #fff;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.5px;
  padding: 1px 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 3px;
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.5);
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 5;
}

.speaking-ring {
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  border: 2px solid #22c55e;
  animation: speakPulse 0.8s ease-in-out infinite;
}

@keyframes speakPulse {
  0%, 100% { opacity: 0.6; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.06); }
}

/* ── Video Containers & Stream Badges ─────────────────── */
.voice-hero-video {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #020617;
  border-radius: inherit;
  overflow: hidden;
}

.voice-hero-video video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #000;
}

.voice-participant-video {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #020617;
  border-radius: inherit;
  overflow: hidden;
}

.voice-participant-video video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #000;
}

.stream-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 700;
  color: white;
  z-index: 5;
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.stream-badge.screen {
  background: rgba(99, 102, 241, 0.9);
}

.stream-badge.camera {
  background: rgba(34, 197, 94, 0.9);
}

.hero-stream-badge {
  position: absolute;
  top: 16px;
  left: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.85rem;
  font-weight: 600;
  color: #f8fafc;
  z-index: 10;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.5);
}

/* ── Stream Overlay (Sibling to Video, z-index 60) ───────────── */
.hero-stream-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 60;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hero-stream-badge,
.hero-stream-toolbar {
  pointer-events: auto;
}

.hero-fullscreen-hint {
  align-self: center;
  margin-bottom: 30px;
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #cbd5e1;
  opacity: 0;
  transform: translateY(6px);
  transition: all 0.25s ease;
  pointer-events: none;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);
}

.voice-hero-card:hover .hero-fullscreen-hint {
  opacity: 1;
  transform: translateY(0);
}

.voice-hero-card.has-video {
  cursor: pointer;
}

/* ── Stream Toolbar Overlay (Top-Right on Hero Video) ───────────── */
.hero-stream-toolbar {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 65;
}

.stream-tool-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4);
}

.stream-tool-btn:hover {
  background: rgba(30, 41, 59, 0.95);
  border-color: rgba(255, 255, 255, 0.3);
  color: #38bdf8;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.6);
}

.stream-tool-btn.fullscreen-btn {
  background: rgba(88, 101, 242, 0.3);
  border-color: rgba(88, 101, 242, 0.6);
  color: #c7d2fe;
}

.stream-tool-btn.fullscreen-btn:hover {
  background: #5865f2;
  color: #ffffff;
  box-shadow: 0 0 18px rgba(88, 101, 242, 0.7);
  transform: scale(1.08);
}

.voice-hero-control-button.fullscreen-main-btn {
  background: rgba(88, 101, 242, 0.2);
  border: 1px solid rgba(88, 101, 242, 0.4);
  color: #c7d2fe;
}

.voice-hero-control-button.fullscreen-main-btn:hover {
  background: #5865f2;
  color: #ffffff;
  box-shadow: 0 0 16px rgba(88, 101, 242, 0.6);
}

.stream-tool-btn.active {
  background: #5865f2;
  border-color: #6366f1;
  color: #ffffff;
}

.stream-tool-btn.muted {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.5);
  color: #f87171;
}

.stream-toolbar-vol-group {
  position: relative;
  display: flex;
  align-items: center;
}

.stream-vol-popup {
  position: absolute;
  top: 46px;
  right: 0;
  background: rgba(15, 23, 42, 0.95);
  backdrop-filter: blur(18px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7);
  z-index: 40;
  animation: fadeInPopup 0.18s ease-out;
}

@keyframes fadeInPopup {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.stream-vol-text {
  font-size: 12px;
  font-weight: 700;
  color: #38bdf8;
  min-width: 36px;
  text-align: right;
  font-family: monospace;
}

.stream-vol-slider {
  width: 110px;
  accent-color: #38bdf8;
  cursor: pointer;
}

/* ── Top Header Buttons (No White Default Buttons) ─────────────── */
.voice-session-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.voice-header-btn,
.ghost-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 8px;
  background: rgba(30, 41, 59, 0.75);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #f1f5f9;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.voice-header-btn:hover,
.ghost-button:hover {
  background: rgba(51, 65, 85, 0.9);
  border-color: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
}

.voice-header-btn.active,
.ghost-button.active {
  background: #5865f2;
  border-color: #6366f1;
  color: #ffffff;
}

/* ── Hero Controls Select & Bitrate / Network Display ───────────── */
.voice-hero-controls-select {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(12px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.net-icon {
  color: #22c55e;
  flex-shrink: 0;
}

.net-stat-pill {
  font-size: 11px;
  font-weight: 700;
  color: #22c55e;
  background: rgba(34, 197, 94, 0.15);
  padding: 3px 7px;
  border-radius: 6px;
  font-family: monospace;
  white-space: nowrap;
}

.quality-select {
  background: #1e293b;
  color: #f8fafc;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
}

.quality-select:hover,
.quality-select:focus {
  border-color: #5865f2;
  background: #273549;
  box-shadow: 0 0 12px rgba(88, 101, 242, 0.35);
}

.quality-select option {
  background: #0f172a;
  color: #f8fafc;
  padding: 6px;
}

/* ── Fullscreen Card Mode ───────────────────────────────────────── */
.voice-hero-card.is-fullscreen {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 99999 !important;
  border-radius: 0 !important;
  margin: 0 !important;
  max-width: none !important;
  max-height: none !important;
  border: none !important;
}

/* ── Theatre Mode (Expanded Stage) ──────────────────────────────── */
.voice-session-view.is-theatre .voice-session-hero {
  flex: 1;
  padding: 12px 20px;
  min-height: calc(100% - 150px);
}

.voice-session-view.is-theatre .voice-session-panels {
  height: 96px;
  padding: 0 20px 12px;
}

.voice-session-view.is-theatre .voice-participant-card {
  min-width: 110px;
  max-width: 110px;
}

.voice-session-view.is-theatre .voice-participant-avatar {
  width: 44px;
  height: 44px;
  font-size: 1.1rem;
}

/* ── In-Call Device Settings Modal ────────────────────────────── */
.voice-device-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(8px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeInModal 0.2s ease;
}

@keyframes fadeInModal {
  from { opacity: 0; transform: scale(0.96); }
  to { opacity: 1; transform: scale(1); }
}

.voice-device-modal {
  width: 100%;
  max-width: 460px;
  background: #1e1f22;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.voice-device-modal-header {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
}

.voice-device-modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}

.voice-modal-close-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.voice-modal-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.voice-device-modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 80vh;
  overflow-y: auto;
}

.voice-modal-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.voice-modal-field label {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.voice-modal-select {
  width: 100%;
  padding: 10px 14px;
  background: #2b2d31;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  outline: none;
  cursor: pointer;
  transition: border-color 0.15s ease;
}

.voice-modal-select:hover,
.voice-modal-select:focus {
  border-color: #5865f2;
}

.voice-modal-select option {
  background: #1e1f22;
  color: #fff;
  padding: 8px;
}

.voice-modal-camera-preview {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 12px;
}

.preview-toggle-btn {
  background: #5865f2;
  border: none;
  color: #fff;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}

.preview-toggle-btn:hover {
  background: #4752c4;
}

.in-call-preview-box {
  width: 100%;
  height: 180px;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  margin-top: 8px;
}

.in-call-preview-box video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scaleX(-1);
}

.voice-modal-krus-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background: rgba(88, 101, 242, 0.1);
  border: 1px solid rgba(88, 101, 242, 0.25);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.voice-modal-krus-toggle:hover {
  background: rgba(88, 101, 242, 0.18);
  border-color: rgba(88, 101, 242, 0.4);
}

.voice-modal-full-settings-btn {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #dbdee1;
  padding: 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  margin-top: 4px;
}

.voice-modal-full-settings-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.voice-session-view.is-theatre .voice-hero-controls {
  bottom: 120px;
}

/* Quick In-Call Camera Effects Chips */
.incall-effects-group {
  margin-top: 10px;
}

.incall-effects-group label {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  display: block;
  margin-bottom: 6px;
}

.incall-chips-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.incall-chip-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #cbd5e1;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;
}

.incall-chip-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.incall-chip-btn.active {
  background: rgba(88, 101, 242, 0.25);
  border-color: #5865f2;
  color: #fff;
  font-weight: 700;
}

/* ── Modern Seamless Fullscreen Mode ──────────────────────────── */
.voice-hero-card:fullscreen,
.voice-hero-card:-webkit-full-screen,
.voice-hero-card.is-fullscreen {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  border-radius: 0 !important;
  border: none !important;
  background: #000000 !important;
  box-shadow: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.voice-hero-card:fullscreen .voice-hero-video,
.voice-hero-card:-webkit-full-screen .voice-hero-video,
.voice-hero-card.is-fullscreen .voice-hero-video {
  width: 100vw !important;
  height: 100vh !important;
  position: absolute !important;
  inset: 0 !important;
}

.voice-hero-card:fullscreen .voice-hero-video video,
.voice-hero-card:-webkit-full-screen .voice-hero-video video,
.voice-hero-card.is-fullscreen .voice-hero-video video {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  background: #000000 !important;
}

.voice-hero-card:fullscreen .voice-hero-controls,
.voice-hero-card:-webkit-full-screen .voice-hero-controls,
.voice-hero-card.is-fullscreen .voice-hero-controls {
  bottom: 30px !important;
  z-index: 99999 !important;
}

/* Soundboard Reactions in Voice Channel */
.voice-soundboard-reaction-stream {
  position: absolute;
  bottom: 85px;
  right: 28px;
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;
  pointer-events: none;
  z-index: 1000;
}

.soundboard-reaction-bubble {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: rgba(18, 19, 23, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6), 0 0 12px rgba(88, 101, 242, 0.3);
  backdrop-filter: blur(12px);
  animation: reactionFlyUp 0.35s cubic-bezier(0.16, 1, 0.3, 1), reactionFadeOut 0.5s ease 3s forwards;
}

@keyframes reactionFlyUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.85);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes reactionFadeOut {
  to {
    opacity: 0;
    transform: translateY(-15px) scale(0.95);
  }
}

.soundboard-reaction-bubble .reaction-emoji {
  font-size: 20px;
  line-height: 1;
}

.soundboard-reaction-bubble .reaction-user {
  font-size: 12px;
  font-weight: 700;
  color: #fff;
}

.soundboard-reaction-bubble .reaction-name {
  font-size: 12px;
  font-weight: 500;
  color: #949ba4;
}




`, "",{"version":3,"sources":["webpack://./src/components/VoiceSessionView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iCAAiC;EACjC,2BAA2B;EAC3B,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,SAAS;EACT,aAAa,EAAE,0BAA0B;EACzC,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,iDAAiD;EACjD,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;;EAEE,gCAAgC;EAChC,yEAAyE;EACzE,mDAAmD;AACrD;;AAEA;EACE,WAAW,mBAAmB,EAAE,8DAA8D,EAAE;EAChG,MAAM,sBAAsB,EAAE,8DAA8D,EAAE;AAChG;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,oFAAoF;EACpF,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,8CAA8C;EAC9C,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,sBAAsB,EAAE;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kCAAkC;EAClC,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,WAAW;EACX,oBAAoB;EACpB,oGAAoG;AACtG;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;;;EAGE,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW,EAAE,qBAAqB;EAClC,YAAY;EACZ,kBAAkB,EAAE,6BAA6B;EACjD,qCAAqC;EACrC,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa,EAAE,oBAAoB;AACrC;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gDAAgD;;AAEhD,yBAAyB;AACzB;EACE,qCAAqC;AACvC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA,mCAAmC,WAAW,EAAE,mBAAmB,EAAE;AACrE,mCAAmC,YAAY,EAAE,sBAAsB,EAAE;AACzE,mCAAmC,WAAW,EAAE,qBAAqB,EAAE;AACvE,mCAAmC,YAAY,EAAE,qBAAqB,EAAE;;AAExE;EACE,OAAO,sBAAsB,EAAE,YAAY,EAAE;EAC7C,OAAO,oBAAoB,EAAE,UAAU,EAAE;AAC3C;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,sBAAsB,mCAAmC,EAAE,YAAY,EAAE;AACzE,uBAAuB,oCAAoC,EAAE,cAAc,EAAE;AAC7E,sBAAsB,mCAAmC,EAAE,YAAY,EAAE;AACzE,sBAAsB,oCAAoC,EAAE,YAAY,EAAE;;AAE1E,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,qDAAqD;EACrD,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;EAC5C,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,sBAAsB,EAAE;AAC5C;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,yCAAyC;AAC3C;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,cAAc;EACd,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,cAAc;EACd,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA,sEAAsE;AACtE;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,sEAAsE;AACtE;EACE,OAAO;EACP,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kDAAkD;EAClD,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mCAAmC;AACrC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;;;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;;;EAGE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,2CAA2C;EAC3C,oBAAoB;EACpB,2EAA2E;EAC3E,2BAA2B;EAC3B,mGAAmG;AACrG;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;AACF;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".voice-session-view {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background-color: #0f172a;\n  color: white;\n  position: relative;\n  overflow: hidden;\n  font-family: 'Inter', sans-serif;\n}\n\n.voice-source-picker {\n  position: absolute;\n  top: 80px;\n  right: 24px;\n  background: rgba(30, 41, 59, 0.9);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 8px;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.voice-source-option {\n  padding: 8px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  transition: background 0.2s;\n}\n\n.voice-source-option:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.voice-source-option.active {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.voice-session-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  background: rgba(15, 23, 42, 0.8);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  z-index: 10;\n}\n\n.voice-session-header-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.voice-session-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #ef4444, #991b1b);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);\n}\n\n.voice-session-channel-name {\n  font-weight: 700;\n  font-size: 1.1rem;\n  color: #f8fafc;\n}\n\n.voice-session-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.8rem;\n  color: #94a3b8;\n}\n\n.voice-session-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.voice-session-status.connected::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: #22c55e;\n  box-shadow: 0 0 8px #22c55e;\n}\n\n.voice-session-subheader {\n  padding: 12px 24px;\n  background: rgba(0, 0, 0, 0.2);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.02);\n}\n\n.voice-session-pill {\n  background: rgba(255, 255, 255, 0.05);\n  padding: 4px 10px;\n  border-radius: 100px;\n  color: #ef4444;\n  font-weight: 600;\n  font-family: monospace;\n}\n\n.voice-session-hero {\n  flex: 1;\n  display: flex;\n  padding: 24px;\n  gap: 20px;\n  min-height: 0; /* Önemli: taşmayı önler */\n  overflow: hidden;\n}\n\n.voice-hero-card {\n  flex: 2;\n  border-radius: 24px;\n  background-color: #1e293b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.voice-hero-avatar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n.voice-hero-avatar img {\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 6px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\n  transition: all 0.25s ease;\n}\n\n.voice-hero-avatar .voice-hero-initial {\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  background: #5865f2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 4rem;\n  font-weight: 800;\n  color: #fff;\n  border: 6px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\n  transition: all 0.25s ease;\n}\n\n.voice-hero-avatar.speaking img,\n.voice-hero-avatar.speaking .voice-hero-initial {\n  border-color: #22c55e !important;\n  box-shadow: 0 0 0 4px #22c55e, 0 0 35px rgba(34, 197, 94, 0.6) !important;\n  animation: heroSpeakPulse 1.2s ease-in-out infinite;\n}\n\n@keyframes heroSpeakPulse {\n  0%, 100% { transform: scale(1); box-shadow: 0 0 0 4px #22c55e, 0 0 25px rgba(34, 197, 94, 0.5); }\n  50% { transform: scale(1.04); box-shadow: 0 0 0 6px #22c55e, 0 0 40px rgba(34, 197, 94, 0.8); }\n}\n\n.hero-name-label {\n  font-size: 1.5rem;\n  font-weight: 800;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);\n}\n\n/* Network Warning Banner */\n.voice-network-warning-banner {\n  background: linear-gradient(90deg, rgba(234, 88, 12, 0.95), rgba(220, 38, 38, 0.92));\n  color: white;\n  padding: 8px 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 13px;\n  box-shadow: 0 4px 14px rgba(220, 38, 38, 0.35);\n  z-index: 50;\n  animation: bannerSlideDown 0.3s ease-out;\n}\n\n@keyframes bannerSlideDown {\n  from { transform: translateY(-100%); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.net-warn-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.net-warn-icon {\n  color: #fef08a;\n  animation: warnPulse 1.2s infinite ease-in-out;\n}\n\n@keyframes warnPulse {\n  0%, 100% { opacity: 0.8; transform: scale(1); }\n  50% { opacity: 1; transform: scale(1.15); }\n}\n\n.net-warn-close-btn {\n  background: rgba(0, 0, 0, 0.25);\n  border: none;\n  color: white;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.net-warn-close-btn:hover {\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.voice-session-panels {\n  height: 110px;\n  max-height: 110px;\n  flex-shrink: 0;\n  padding: 0 24px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  position: relative;\n  z-index: 10;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.voice-session-panels.collapsed {\n  height: 26px;\n  max-height: 26px;\n  padding: 0 24px 2px;\n}\n\n.dock-toggle-tab {\n  align-self: center;\n  background: rgba(15, 23, 42, 0.85);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #94a3b8;\n  padding: 2px 14px;\n  border-radius: 12px 12px 0 0;\n  font-size: 11px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.dock-toggle-tab:hover {\n  background: #1e293b;\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.25);\n  transform: translateY(-2px);\n}\n\n.voice-participants-panel {\n  flex: 1;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(14px);\n  border-radius: 16px;\n  padding: 6px 12px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  display: flex;\n  align-items: center;\n}\n\n.voice-participants-grid {\n  display: flex;\n  gap: 12px;\n  height: 100%;\n  align-items: center;\n}\n\n.voice-participant-card {\n  min-width: 140px;\n  max-width: 160px;\n  height: 80px;\n  background: #1e293b;\n  border-radius: 12px;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  flex-shrink: 0;\n}\n\n.voice-participant-card:hover {\n  transform: translateY(-2px);\n  background: #334155;\n}\n\n.voice-participant-card.speaking {\n  border-color: #22c55e;\n  box-shadow: 0 0 15px rgba(34, 197, 94, 0.4);\n}\n\n.voice-participant-card.is-streaming {\n  border-color: rgba(99, 102, 241, 0.6);\n  box-shadow: 0 0 12px rgba(99, 102, 241, 0.3);\n}\n\n.voice-participant-media {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.voice-participant-avatar span {\n  font-size: 1.3rem;\n  font-weight: 700;\n}\n\n.voice-hero-controls {\n  position: absolute;\n  bottom: 14px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 14px;\n  padding: 8px 18px;\n  background: rgba(15, 23, 42, 0.92);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.7);\n  z-index: 70;\n  pointer-events: auto;\n  transition: opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1), transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.voice-hero-controls.auto-hidden {\n  opacity: 0;\n  pointer-events: none;\n  transform: translate(-50%, 20px);\n}\n\n.voice-hero-controls.visible,\n.voice-hero-controls:hover,\n.voice-hero-card:hover .voice-hero-controls {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translate(-50%, 0);\n}\n\n.voice-hero-controls-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\n\n.voice-hero-control-button {\n  width: 42px; /* Biraz küçültüldü */\n  height: 42px;\n  border-radius: 8px; /* Daha modern karemsi yapı */\n  background: rgba(255, 255, 255, 0.05);\n  border: none;\n  color: #f8fafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.voice-hero-control-button:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: scale(1.1);\n}\n\n.voice-hero-control-button.active {\n  background: #fff;\n  color: #0f172a;\n}\n\n.voice-hero-control-button.krus-btn.active {\n  background: linear-gradient(135deg, #5865F2, #8b5cf6);\n  color: #ffffff;\n  box-shadow: 0 0 16px rgba(88, 101, 242, 0.6);\n}\n\n.voice-hero-control-button.danger {\n  background: #ef4444;\n  color: white;\n}\n\n.voice-hero-control-button.danger:hover {\n  background: #dc2626;\n  box-shadow: 0 0 20px rgba(239, 68, 68, 0.4);\n}\n\n/* Whiteboard Area (Hidden by default) */\n.whiteboard-panel {\n  position: absolute;\n  top: 80px;\n  right: 24px;\n  width: 400px;\n  height: calc(100% - 310px);\n  background: white;\n  border-radius: 16px;\n  z-index: 5;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  display: none; /* JS ile açılacak */\n}\n\n/* Custom Scrollbar */\n.voice-participants-panel::-webkit-scrollbar {\n  height: 6px;\n}\n\n.voice-participants-panel::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.voice-participants-panel::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n}\n\n.voice-participants-panel::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* ---- New participant card enhancements ---- */\n\n/* Local user highlight */\n.voice-participant-card.is-local {\n  border-color: rgba(239, 68, 68, 0.35);\n}\n\n/* Speaking bars animation */\n.speaking-bars {\n  position: absolute;\n  bottom: 36px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: flex-end;\n  gap: 3px;\n  height: 16px;\n}\n\n.speaking-bars span {\n  width: 3px;\n  border-radius: 2px;\n  background: #22c55e;\n  animation: speakBar 0.5s ease-in-out infinite alternate;\n}\n\n.speaking-bars span:nth-child(1) { height: 6px; animation-delay: 0s; }\n.speaking-bars span:nth-child(2) { height: 12px; animation-delay: 0.15s; }\n.speaking-bars span:nth-child(3) { height: 8px; animation-delay: 0.3s; }\n.speaking-bars span:nth-child(4) { height: 14px; animation-delay: 0.1s; }\n\n@keyframes speakBar {\n  from { transform: scaleY(0.4); opacity: 0.7; }\n  to   { transform: scaleY(1); opacity: 1; }\n}\n\n/* Status icons row (top-right corner of card) */\n.participant-status-icons {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  display: flex;\n  flex-direction: row;\n  gap: 3px;\n}\n\n.status-icon {\n  width: 18px;\n  height: 18px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n}\n\n.muted-icon-badge   { background: rgba(239, 68, 68, 0.85); color: white; }\n.deafened-icon-badge { background: rgba(251, 191, 36, 0.85); color: #1a1a1a; }\n.camera-icon-badge  { background: rgba(34, 197, 94, 0.85); color: white; }\n.screen-icon-badge  { background: rgba(99, 102, 241, 0.85); color: white; }\n\n/* Participant name tag */\n.voice-participant-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 6px 8px;\n  background: linear-gradient(transparent, rgba(0,0,0,0.75));\n}\n\n.participant-name-tag {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #f8fafc;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.local-badge {\n  background: #ef4444;\n  color: white;\n  font-size: 0.6rem;\n  font-weight: 700;\n  padding: 1px 4px;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  flex-shrink: 0;\n}\n\n/* Voice participant avatar centered in card */\n.voice-participant-avatar {\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: white;\n  position: relative;\n  flex-shrink: 0;\n  margin-bottom: 12px;\n}\n\n.voice-participant-avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.participant-live-pill {\n  position: absolute;\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: linear-gradient(135deg, #ef4444, #e11d48);\n  color: #fff;\n  font-size: 8px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  padding: 1px 5px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.5);\n  white-space: nowrap;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  z-index: 5;\n}\n\n.speaking-ring {\n  position: absolute;\n  inset: -4px;\n  border-radius: 50%;\n  border: 2px solid #22c55e;\n  animation: speakPulse 0.8s ease-in-out infinite;\n}\n\n@keyframes speakPulse {\n  0%, 100% { opacity: 0.6; transform: scale(1); }\n  50% { opacity: 1; transform: scale(1.06); }\n}\n\n/* ── Video Containers & Stream Badges ─────────────────── */\n.voice-hero-video {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #020617;\n  border-radius: inherit;\n  overflow: hidden;\n}\n\n.voice-hero-video video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background-color: #000;\n}\n\n.voice-participant-video {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #020617;\n  border-radius: inherit;\n  overflow: hidden;\n}\n\n.voice-participant-video video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background-color: #000;\n}\n\n.stream-badge {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: white;\n  z-index: 5;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n}\n\n.stream-badge.screen {\n  background: rgba(99, 102, 241, 0.9);\n}\n\n.stream-badge.camera {\n  background: rgba(34, 197, 94, 0.9);\n}\n\n.hero-stream-badge {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.85);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #f8fafc;\n  z-index: 10;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.5);\n}\n\n/* ── Stream Overlay (Sibling to Video, z-index 60) ───────────── */\n.hero-stream-overlay {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  z-index: 60;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.hero-stream-badge,\n.hero-stream-toolbar {\n  pointer-events: auto;\n}\n\n.hero-fullscreen-hint {\n  align-self: center;\n  margin-bottom: 30px;\n  background: rgba(15, 23, 42, 0.85);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #cbd5e1;\n  opacity: 0;\n  transform: translateY(6px);\n  transition: all 0.25s ease;\n  pointer-events: none;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);\n}\n\n.voice-hero-card:hover .hero-fullscreen-hint {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.voice-hero-card.has-video {\n  cursor: pointer;\n}\n\n/* ── Stream Toolbar Overlay (Top-Right on Hero Video) ───────────── */\n.hero-stream-toolbar {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  z-index: 65;\n}\n\n.stream-tool-btn {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.85);\n  backdrop-filter: blur(14px);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: #f1f5f9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4);\n}\n\n.stream-tool-btn:hover {\n  background: rgba(30, 41, 59, 0.95);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: #38bdf8;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.6);\n}\n\n.stream-tool-btn.fullscreen-btn {\n  background: rgba(88, 101, 242, 0.3);\n  border-color: rgba(88, 101, 242, 0.6);\n  color: #c7d2fe;\n}\n\n.stream-tool-btn.fullscreen-btn:hover {\n  background: #5865f2;\n  color: #ffffff;\n  box-shadow: 0 0 18px rgba(88, 101, 242, 0.7);\n  transform: scale(1.08);\n}\n\n.voice-hero-control-button.fullscreen-main-btn {\n  background: rgba(88, 101, 242, 0.2);\n  border: 1px solid rgba(88, 101, 242, 0.4);\n  color: #c7d2fe;\n}\n\n.voice-hero-control-button.fullscreen-main-btn:hover {\n  background: #5865f2;\n  color: #ffffff;\n  box-shadow: 0 0 16px rgba(88, 101, 242, 0.6);\n}\n\n.stream-tool-btn.active {\n  background: #5865f2;\n  border-color: #6366f1;\n  color: #ffffff;\n}\n\n.stream-tool-btn.muted {\n  background: rgba(239, 68, 68, 0.2);\n  border-color: rgba(239, 68, 68, 0.5);\n  color: #f87171;\n}\n\n.stream-toolbar-vol-group {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.stream-vol-popup {\n  position: absolute;\n  top: 46px;\n  right: 0;\n  background: rgba(15, 23, 42, 0.95);\n  backdrop-filter: blur(18px);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  padding: 10px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7);\n  z-index: 40;\n  animation: fadeInPopup 0.18s ease-out;\n}\n\n@keyframes fadeInPopup {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.stream-vol-text {\n  font-size: 12px;\n  font-weight: 700;\n  color: #38bdf8;\n  min-width: 36px;\n  text-align: right;\n  font-family: monospace;\n}\n\n.stream-vol-slider {\n  width: 110px;\n  accent-color: #38bdf8;\n  cursor: pointer;\n}\n\n/* ── Top Header Buttons (No White Default Buttons) ─────────────── */\n.voice-session-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.voice-header-btn,\n.ghost-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  background: rgba(30, 41, 59, 0.75);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #f1f5f9;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n\n.voice-header-btn:hover,\n.ghost-button:hover {\n  background: rgba(51, 65, 85, 0.9);\n  border-color: rgba(255, 255, 255, 0.25);\n  color: #ffffff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);\n}\n\n.voice-header-btn.active,\n.ghost-button.active {\n  background: #5865f2;\n  border-color: #6366f1;\n  color: #ffffff;\n}\n\n/* ── Hero Controls Select & Bitrate / Network Display ───────────── */\n.voice-hero-controls-select {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: rgba(15, 23, 42, 0.8);\n  backdrop-filter: blur(12px);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.net-icon {\n  color: #22c55e;\n  flex-shrink: 0;\n}\n\n.net-stat-pill {\n  font-size: 11px;\n  font-weight: 700;\n  color: #22c55e;\n  background: rgba(34, 197, 94, 0.15);\n  padding: 3px 7px;\n  border-radius: 6px;\n  font-family: monospace;\n  white-space: nowrap;\n}\n\n.quality-select {\n  background: #1e293b;\n  color: #f8fafc;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s;\n}\n\n.quality-select:hover,\n.quality-select:focus {\n  border-color: #5865f2;\n  background: #273549;\n  box-shadow: 0 0 12px rgba(88, 101, 242, 0.35);\n}\n\n.quality-select option {\n  background: #0f172a;\n  color: #f8fafc;\n  padding: 6px;\n}\n\n/* ── Fullscreen Card Mode ───────────────────────────────────────── */\n.voice-hero-card.is-fullscreen {\n  position: fixed !important;\n  inset: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  z-index: 99999 !important;\n  border-radius: 0 !important;\n  margin: 0 !important;\n  max-width: none !important;\n  max-height: none !important;\n  border: none !important;\n}\n\n/* ── Theatre Mode (Expanded Stage) ──────────────────────────────── */\n.voice-session-view.is-theatre .voice-session-hero {\n  flex: 1;\n  padding: 12px 20px;\n  min-height: calc(100% - 150px);\n}\n\n.voice-session-view.is-theatre .voice-session-panels {\n  height: 96px;\n  padding: 0 20px 12px;\n}\n\n.voice-session-view.is-theatre .voice-participant-card {\n  min-width: 110px;\n  max-width: 110px;\n}\n\n.voice-session-view.is-theatre .voice-participant-avatar {\n  width: 44px;\n  height: 44px;\n  font-size: 1.1rem;\n}\n\n/* ── In-Call Device Settings Modal ────────────────────────────── */\n.voice-device-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  backdrop-filter: blur(8px);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: fadeInModal 0.2s ease;\n}\n\n@keyframes fadeInModal {\n  from { opacity: 0; transform: scale(0.96); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.voice-device-modal {\n  width: 100%;\n  max-width: 460px;\n  background: #1e1f22;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 14px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.7);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.voice-device-modal-header {\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.voice-device-modal-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.voice-modal-close-btn {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.voice-modal-close-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.voice-device-modal-body {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.voice-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.voice-modal-field label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #94a3b8;\n  letter-spacing: 0.5px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.voice-modal-select {\n  width: 100%;\n  padding: 10px 14px;\n  background: #2b2d31;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  outline: none;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n}\n\n.voice-modal-select:hover,\n.voice-modal-select:focus {\n  border-color: #5865f2;\n}\n\n.voice-modal-select option {\n  background: #1e1f22;\n  color: #fff;\n  padding: 8px;\n}\n\n.voice-modal-camera-preview {\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.preview-toggle-btn {\n  background: #5865f2;\n  border: none;\n  color: #fff;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.preview-toggle-btn:hover {\n  background: #4752c4;\n}\n\n.in-call-preview-box {\n  width: 100%;\n  height: 180px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #000;\n  margin-top: 8px;\n}\n\n.in-call-preview-box video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transform: scaleX(-1);\n}\n\n.voice-modal-krus-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  background: rgba(88, 101, 242, 0.1);\n  border: 1px solid rgba(88, 101, 242, 0.25);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.voice-modal-krus-toggle:hover {\n  background: rgba(88, 101, 242, 0.18);\n  border-color: rgba(88, 101, 242, 0.4);\n}\n\n.voice-modal-full-settings-btn {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #dbdee1;\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  margin-top: 4px;\n}\n\n.voice-modal-full-settings-btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n}\n\n.voice-session-view.is-theatre .voice-hero-controls {\n  bottom: 120px;\n}\n\n/* Quick In-Call Camera Effects Chips */\n.incall-effects-group {\n  margin-top: 10px;\n}\n\n.incall-effects-group label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #94a3b8;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.incall-chips-row {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.incall-chip-btn {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #cbd5e1;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  user-select: none;\n}\n\n.incall-chip-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.incall-chip-btn.active {\n  background: rgba(88, 101, 242, 0.25);\n  border-color: #5865f2;\n  color: #fff;\n  font-weight: 700;\n}\n\n/* ── Modern Seamless Fullscreen Mode ──────────────────────────── */\n.voice-hero-card:fullscreen,\n.voice-hero-card:-webkit-full-screen,\n.voice-hero-card.is-fullscreen {\n  width: 100vw !important;\n  height: 100vh !important;\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  border-radius: 0 !important;\n  border: none !important;\n  background: #000000 !important;\n  box-shadow: none !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.voice-hero-card:fullscreen .voice-hero-video,\n.voice-hero-card:-webkit-full-screen .voice-hero-video,\n.voice-hero-card.is-fullscreen .voice-hero-video {\n  width: 100vw !important;\n  height: 100vh !important;\n  position: absolute !important;\n  inset: 0 !important;\n}\n\n.voice-hero-card:fullscreen .voice-hero-video video,\n.voice-hero-card:-webkit-full-screen .voice-hero-video video,\n.voice-hero-card.is-fullscreen .voice-hero-video video {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: contain !important;\n  background: #000000 !important;\n}\n\n.voice-hero-card:fullscreen .voice-hero-controls,\n.voice-hero-card:-webkit-full-screen .voice-hero-controls,\n.voice-hero-card.is-fullscreen .voice-hero-controls {\n  bottom: 30px !important;\n  z-index: 99999 !important;\n}\n\n/* Soundboard Reactions in Voice Channel */\n.voice-soundboard-reaction-stream {\n  position: absolute;\n  bottom: 85px;\n  right: 28px;\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 10px;\n  pointer-events: none;\n  z-index: 1000;\n}\n\n.soundboard-reaction-bubble {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  background: rgba(18, 19, 23, 0.92);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 999px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6), 0 0 12px rgba(88, 101, 242, 0.3);\n  backdrop-filter: blur(12px);\n  animation: reactionFlyUp 0.35s cubic-bezier(0.16, 1, 0.3, 1), reactionFadeOut 0.5s ease 3s forwards;\n}\n\n@keyframes reactionFlyUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.85);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes reactionFadeOut {\n  to {\n    opacity: 0;\n    transform: translateY(-15px) scale(0.95);\n  }\n}\n\n.soundboard-reaction-bubble .reaction-emoji {\n  font-size: 20px;\n  line-height: 1;\n}\n\n.soundboard-reaction-bubble .reaction-user {\n  font-size: 12px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.soundboard-reaction-bubble .reaction-name {\n  font-size: 12px;\n  font-weight: 500;\n  color: #949ba4;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
